/** Confidence labels for application scan UI (real extraction only). */

export const CONFIDENCE_LABELS = {
  auto: 'Auto-filled',
  review: 'Review',
  needs_review: 'Needs review',
};
